import { render } from "./ContactView.vue?vue&type=template&id=e4f82c92&scoped=true&ts=true"
import script from "./ContactView.vue?vue&type=script&lang=ts"
export * from "./ContactView.vue?vue&type=script&lang=ts"

import "./style/contact.scss?vue&type=style&index=0&id=e4f82c92&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4f82c92"]])

export default __exports__